module.exports = __webpack_public_path__ + "img/sketch2.96e28b25.jpg";